import React, { Component } from "react";
import * as aor from "react-admin";
import { change, submit, isSubmitting } from "redux-form";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { withStyles, Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TranslatedText from "./TranslatedText";
import { getLoggedUserId } from "../common/authClient";
import restClient from "../common/restClient";
import IconRocket from "../common/icons/svgRocket";
import HelpIcon from "@material-ui/icons/Help";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
    getMultiTenantAccesUrl,
    getOperationParams
} from "../common/utilities";
import { OperationType } from "../common/operationTypes";

import {
    fetchEnd,
    fetchStart,
    showNotification,
    SimpleForm,
    Labeled,
    TextInput,
    CREATE
} from "react-admin";

const MY_FORM_NAME = "form-run-installation";

const styles = {
    button: {
        position: "relative",
        top: 24,
        marginLeft: 50
    }
};

const MyActivityField = props => {
    const { record } = props;
    if (record && record.activity !== undefined) {
        const activity_resource_name = `resources.tickets.activity_decoder.${record.activity}`;
        return (
            <Labeled label="resources.tickets.fields.activity">
                <span>
                    <TranslatedText resource_name={activity_resource_name} />
                </span>
            </Labeled>
        );
    } else {
        return <Labeled label="Undefined activity" />;
    }
};

class NewInstallationRunner extends Component {
    state = {
        showDialog: false,
        showConfirmDialog: false,
        disableButton: false,
        customerUrl: "",
        opInProgress: false,
        multi_tenant_url: null,
        user_params: null,
        dynamic_params: null
    };

    componentDidMount = () => {
        getOperationParams(
            this.props.record.installation_type_id,
            OperationType.Installation
        ).then(params => this.setState({ user_params: params.user_prompt }));

        getMultiTenantAccesUrl(this.props.record.installation_type_id).then(
            multitenant_url =>
                this.setState({ multi_tenant_access_url: multitenant_url })
        );
    };

    handleCancel = () => {
        this.setState({
            showDialog: false,
            disableButton: false
        });
    };

    handleOk = event => {
        const { submit } = this.props;
        // Trigger a submit of our custom quick create form
        // This is needed because our modal action buttons are oustide the form
        submit(`${MY_FORM_NAME}_${this.props.id}`);
    };

    handleClick = () => {
        this.setState({ showDialog: true });
    };

    handleSubmit = values => {
        const { showNotification } = this.props;

        if (values.customer_url !== null && values.customer_url !== "") {
            this.setState({
                showConfirmDialog: true,
                customerUrl: values.customer_url
            });
        } else {
            this.setState({ customerUrl: "" });
            showNotification("customer_url_empty", "error");
        }

        const dynamic_params = Object.assign({}, values);
        delete dynamic_params.customer_url;
        if (!Object.keys(dynamic_params).length !== 0) {
            this.setState({
                dynamic_params: dynamic_params
            });
        }
    };

    validateInstallation = async (ticket_id, installation_type_id, cnt) => {
        // incremento il contatore tentativi di validazione installazione
        cnt++;
        try {
            // tentativo di validazione installazione
            const response = await restClient(CREATE, "validations", {
                data: {
                    ticket_id: parseInt(ticket_id, 10),
                    installation_type_id: installation_type_id,
                    customer_url: this.state.customerUrl,
                    extra_params: this.state.dynamic_params
                }
            });
            return response;
        } catch (err) {
            // se l'errore non è dovuto al controllo esistenza dell'url o validità della licenza esco restituendo l'errore
            if (err.status !== 410 && err.status !== 403) {
                return err;
            }
            // qui l'errore potrebbe essere dovuto al fatto che la lambda per il controllo licenze o url va in timeout
            // per questo ritentiamo la creazione dell'installazione per almeno 3 volte
            if (cnt < 3) {
                // ritento la validazione dell'installazione
                return await this.validateInstallation(
                    ticket_id,
                    installation_type_id,
                    cnt
                );
            } else {
                // al 3° fallimento restituisco l'errore
                return err;
            }
        }
    };

    handleConfirmOk = async () => {
        const { showNotification, push, ticket_id } = this.props;

        // Dispatch an action letting react-admin know a API call is ongoing
        fetchStart();
        this.setState({ disableButton: true, opInProgress: true });

        // chiamata API per creazione installazione
        const validationResponse = await this.validateInstallation(
            ticket_id,
            this.props.record.installation_type_id,
            0
        );
        try {
            if (
                (validationResponse.data &&
                    validationResponse.data.message !== "All check OK") ||
                !validationResponse.data
            ) {
                throw new Error(validationResponse.message);
            } else {
                // chiamata API per creazione evento InstallationStarted
                await restClient(CREATE, "installations", {
                    data: {
                        ticket_id: parseInt(ticket_id, 10),
                        customer_url: this.state.customerUrl,
                        extra_params: this.state.dynamic_params
                    }
                }).then(
                    response => {
                        if (!response && !response.data) {
                            throw new Error(response.message);
                        } else {
                            // redirect su pagina di dettaglio installazione
                            push(`/installations/${response.data.id}/show`);
                        }
                    },
                    err => {
                        throw new Error(err);
                    }
                );
                this.setState({
                    showDialog: false,
                    disableButton: false,
                    opInProgress: false
                });
            }
        } catch (error) {
            this.setState({
                showDialog: false,
                showConfirmDialog: false,
                disableButton: false,
                opInProgress: false
            });
            showNotification(error.message, "error");
        }
        // Dispatch an action letting react-admin know a API call has ended
        fetchEnd();
    };

    handleConfirmCancel = () => {
        this.setState({ showConfirmDialog: false, opInProgress: false });
    };

    renderConfirmDialog() {
        return this.state.showConfirmDialog ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.showConfirmDialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText resource_name="ra.actions.confirm" />
                    </b>
                </DialogTitle>
                <DialogContent>
                    {!this.state.opInProgress && (
                        <TranslatedText resource_name="resources.tickets.actions.create_installation.confirm" />
                    )}
                </DialogContent>
                <DialogContent>
                    {this.state.opInProgress && (
                        <TranslatedText resource_name="ra.actions.wait" />
                    )}
                </DialogContent>
                <DialogActions>
                    <div align="center">
                        {this.state.opInProgress && <CircularProgress />}
                    </div>
                    {!this.state.opInProgress && (
                        <div>
                            <Button
                                onClick={this.handleConfirmCancel}
                                color="primary"
                            >
                                <TranslatedText resource_name="ra.action.cancel" />
                            </Button>
                            <Button
                                onClick={this.handleConfirmOk}
                                variant="contained"
                                color="secondary"
                            >
                                <TranslatedText resource_name="resources.tickets.actions.create_installation.create_short" />
                            </Button>
                        </div>
                    )}
                </DialogActions>
            </Dialog>
        ) : null;
    }

    getValidate(val_list, required) {
        if (required) {
            val_list.push(aor.required());
        }
        return val_list;
    }

    renderOptionalParams() {
        // checks params in user_params and puts components to insert data
        if (this.state.user_params != null && this.state.user_params !== "") {
            return this.state.user_params.map(element => {
                switch (element.type.toUpperCase()) {
                    case "TEXT":
                        return (
                            <aor.TextInput
                                source={element.name}
                                label={element.label}
                                validate={this.getValidate(
                                    [],
                                    element.required
                                )}
                            />
                        );
                    case "NUMBER":
                        return (
                            <aor.NumberInput
                                source={element.name}
                                label={element.label}
                                validate={this.getValidate(
                                    [aor.number()],
                                    element.required
                                )}
                            />
                        );
                    case "EMAIL":
                        return (
                            <aor.TextInput
                                source={element.name}
                                label={element.label}
                                validate={this.getValidate(
                                    [aor.email()],
                                    element.required
                                )}
                            />
                        );
                    default:
                        return null;
                }
            });
        }
        return null;
    }

    renderDialog() {
        const { record, isSubmitting } = this.props;
        return this.state.showDialog ? (
            <Dialog open={this.state.showDialog}>
                <DialogTitle>
                    <b>
                        <TranslatedText resource_name="resources.tickets.actions.create_installation.create" />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <SimpleForm
                        key={`new_installation_form_${this.props.id}`}
                        // We override the redux-form name to avoid collision with the react-admin main form
                        form={`${MY_FORM_NAME}_${this.props.id}`}
                        resource="posts"
                        // We override the redux-form onSubmit prop to handle the submission ourselves
                        onSubmit={this.handleSubmit}
                        // We want no toolbar at all as we have our modal actions
                        toolbar={null}
                    >
                        <TextInput
                            source="customer_url"
                            label="Customer URL"
                            defaultValue={this.state.multi_tenant_access_url}
                            disabled={this.state.multi_tenant_access_url}
                            InputProps={
                                this.state.multi_tenant_access_url
                                    ? null
                                    : {
                                          endAdornment: (
                                              <InputAdornment position="end">
                                                  <Tooltip
                                                      placement="left"
                                                      title={
                                                          <TranslatedText
                                                              resource_name={`resources.installation_types.url_pattern.${record.installation_type}`}
                                                          />
                                                      }
                                                  >
                                                      <HelpIcon
                                                          style={{
                                                              verticalAlign:
                                                                  "center",
                                                              marginLeft: 20,
                                                              marginBottom: 3
                                                          }}
                                                      />
                                                  </Tooltip>
                                              </InputAdornment>
                                          )
                                      }
                            }
                        />
                        {this.renderOptionalParams()}
                    </SimpleForm>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel} color="primary">
                        <TranslatedText resource_name="ra.action.cancel" />
                    </Button>
                    <Button
                        saving={isSubmitting.toString()}
                        onClick={this.handleOk}
                        variant="contained"
                        color="secondary"
                        redirect="/customers"
                        disabled={this.state.disableButton}
                    >
                        <TranslatedText resource_name="resources.tickets.actions.create_installation.continue" />
                    </Button>
                </DialogActions>
                {this.renderConfirmDialog()}
            </Dialog>
        ) : null;
    }

    render() {
        const {
            record: { activity, installation_id, user_id, status },
            classes: { button }
        } = this.props;
        return (
            <React.Fragment>
                <MyActivityField {...this.props} />
                {installation_id === null &&
                activity === "INSTALLATION" &&
                status === "IN_PROGRESS" &&
                user_id === getLoggedUserId() ? (
                    <Button
                        className={button}
                        color="primary"
                        target="_blank"
                        onClick={this.handleClick}
                    >
                        <IconRocket viewBox="0 0 24 24" />
                        Crea
                    </Button>
                ) : null}
                {this.renderDialog()}
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    change,
    showNotification,
    push,
    submit
};

const mapStateToProps = (state, ownProps) => ({
    isSubmitting: isSubmitting(`${MY_FORM_NAME}_${ownProps.id}`)(state)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(NewInstallationRunner));



// WEBPACK FOOTER //
// ./src/components/NewInstallationRunner.js